import { useStore } from "@tanstack/react-store";
import {
	closeModal as closeModalAction,
	modalStore,
	openModal as openModalAction,
} from "@/store/modal.store";

export function useModal() {
	const modalState = useStore(modalStore, (state) => state);

	return {
		isOpen: modalState.isOpen,
		modalKey: modalState.modalKey,
		data: modalState.data,
		openModal: openModalAction,
		closeModal: closeModalAction,
	};
}

export function useModalState() {
	return useStore(modalStore, (state) => state);
}
